import { Form } from "@/components/ui/form";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { MezzaFormField } from "@/components/core/Form/MezzaFormField";
import { useDeleteRequestMutation } from "@/stores/queries/support.query";
import { ButtonWithLoading } from "@/components/core/Form/ButtonWithLoading";

export function DeleteForm() {
  const { t } = useTranslation();
  const { submitDeleteRequest, isPending } = useDeleteRequestMutation();

  // Define schema inside component to access translation function
  const deleteRequestSchema = z.object({
    description: z
      .string()
      .min(1, t("errors.required"))
      .min(10, t("validation.minLength", { count: 10 }))
      .max(1000, t("errors.maxLength", { max: 1000 })),
  });

  type DeleteRequestFormData = z.infer<typeof deleteRequestSchema>;

  const form = useForm<DeleteRequestFormData>({
    resolver: zodResolver(deleteRequestSchema),
    defaultValues: {
      description: "",
    },
    mode: "all",
  });

  const onSubmit = async (data: DeleteRequestFormData) => {
    await submitDeleteRequest(data);
    form.reset();
  };

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-4 rounded-lg border p-4"
      >
        <MezzaFormField
          form={form}
          name="description"
          label="common.comment"
          placeholder="common.placeholder.deleteReason"
          type="textarea"
          className="min-h-[100px]"
        />

        <ButtonWithLoading
          type="submit"
          className="w-full"
          disabled={form.formState.isSubmitting || isPending}
          isLoading={form.formState.isSubmitting || isPending}
        >
          {t("common.submit")}
        </ButtonWithLoading>
      </form>
    </Form>
  );
} 